import React, { useContext, useEffect, useState } from 'react';
import { Switch, useHistory, useLocation } from 'react-router-dom';
import { DashboardContainer, DashbaordWrapper } from './styles';
import { KeycloakContext, SessionContext } from '../../store/index';
import { logout } from '../../services/authentication';
import { getAdvisor, getContratoAsesor } from '../../services/advisor';
import PrivateRoute from '../../routes/PrivateRoute';
import DashboardPage from '../Dashboard';
import SimulatorPage from '../Simulator';
import SimulationsPage from '../Simulations';
import ClientIdentityValidationPage from '../ClientIdentityValidation'
import ClientListPage from '../ClientList';
import ClientModifyPage from '../ClientModify';
import ClientRegistrationPage from '../ClientRegistration';
import GlobalDebtPage from '../GlobalDebt';
import LifeInsurancePage from '../LifeInsurance';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import MeansOfDisbursementPage from '../MeansOfDisbursement';
import DataSolicitationPage from '../DataSolicitation';
import WelcomeSlider from '../../components/WelcomeSlider';
import ExceptionPage from '../Exception';
import InternationalOperationsPage from '../InternationalOperations';
import ApSecurePage from '../ApSecure';
import ProcessedExceptionsPage from '../ProcessedExceptions';
import DetailExceptionsPage from '../DetailException';
import ReferencesPage from '../References';
import DocumentSigningPage from '../DocumentSigning';
import CdtProductListPage from '../CdtProductList';
import CdtDetail from '../CdtDetail';
import { getMenuByRol } from '../../services/roles';
import SurveyContainer from '../../components/SurveyContainer';
import { getActiveQuestions, getLastSurvey } from '../../services/survey';
import SurveyList from '../SurveyList';
import SurveyDetail from '../SurveyDetail';
import AttachDocumentsPage from '../AttachDocumentsPage';
import ClientProspecting from '../ClientProspecting';
import AgileSimulatorPage from '../AgileSimulator';
import IdentityValidation from '../IdentityValidation';
import ClientIdentityValidation from '../IdentityValidation';
import HabeasDataSenderPage from '../HabeasDataSender';
import ModalInfo from '../../components/ModalInfo';
import colors from '../../assets/styles/colors';
import { BsExclamation } from 'react-icons/bs';
import { ModalInfoBodyLabel } from '../../components/ModalInfo/styles';
import PagosPage from '../Pagos';
import SimuladorRetanqueoPage from '../SimuladorRetanqueo';

const MainPage = () => {
  const history = useHistory();
  const location = useLocation();
  const session = JSON.parse(localStorage.getItem('@EC-session'));
  const { keycloak } = useContext(KeycloakContext);
  const [showWelcomeSlider, setWelcomeSlider] = useState(false);
  const [routesMenuByRolList, setRoutesMenuByRolList] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [asesor, setAsesor] = useState("");
  const [lastDate, setLastDate] = useState();
  const [monthBefore, setMonthBefore] = useState();
  const [hasSurveyDate, setHasSurveyDate] = useState(false);
  const [showModalCorretaje, setShowModalCorretaje] = useState(false);

  async function initializedStateComponent() {
    try {
      const response = await getAdvisor(session.idAsesor);
      setAsesor(session.idAsesor);
      if (!response.data.aceptaCondiciones) {
        history.push('/terms-of-service');
      }

      const routesMenuByRol = await getMenuByRol(session.rol);
      const tempResult = routesMenuByRol.data.menu.map(keyWord => keyWord.items);
      setRoutesMenuByRolList(tempResult.map(keyWord => keyWord.map(link => link.routerLink)).flat(1));
      if(!localStorage.getItem('@EC-userAccess')) {
        localStorage.setItem('@EC-userAccess', JSON.stringify({ access: 0 }));
      }

      const userAccess = JSON.parse(localStorage.getItem('@EC-userAccess'));

      if(userAccess.access < 3 && location.login) {
        setWelcomeSlider(true);
        location.login = false;
      }

      const surveyLastDate = await getLastSurvey(session.idAsesor);
      const surveyQuestions = await getActiveQuestions();
      await setQuestions(surveyQuestions.data);
      if(surveyLastDate.data && surveyLastDate.data.ultimaEncuesta) {
        await setLastDate(Date.parse(surveyLastDate.data.ultimaEncuesta));
        await setHasSurveyDate(true);
      }
      await setMonthBefore(await oneMonthBeforeToday());
      const responseContratoAsesor = await getContratoAsesor(session.idAsesor)
      if(!responseContratoAsesor.data) setShowModalCorretaje(true);
    } catch (error) {
      console.log(error);
    }
  }

  function oneMonthBeforeToday() {
    var time = Date.now();
    time -= (time % 86400000);
    time -= 86400000 * 30;
    return time;
  }

  function setCloseWelcomeModal(bool) {
    let userAccess = JSON.parse(localStorage.getItem('@EC-userAccess'));
    userAccess.access = userAccess.access + 1;

    localStorage.setItem('@EC-userAccess', JSON.stringify(userAccess));
    setWelcomeSlider(bool);
  }

  useEffect(() => {
    initializedStateComponent();
  }, [])

  return (
    <SessionContext.Provider value={session}>
      <DashboardContainer id="main-page">
      <Sidebar routesByRol = {routesMenuByRolList} />
        {showWelcomeSlider && <WelcomeSlider setShow={setCloseWelcomeModal} />}
        <DashbaordWrapper>
          <Header session={session} logout={() => logout(keycloak)} />
          <Switch>
            <PrivateRoute exact path="/admin/dashboard" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/pendientes_radicar") && 
                <DashboardPage canalEstado="digicredito" titulo="Mis Solicitudes" descripcion="Pendientes por Radicar"/>
              }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/radicadas" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/radicadas") &&
                <DashboardPage canalEstado="abacus" titulo="Mis Solicitudes" descripcion="Estado de crédito"/>
              }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/pendientes_adjuntar" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/pendientes_adjuntar") &&
                <DashboardPage canalEstado='adjuntar' titulo="Mis Solicitudes" descripcion="Pendientes por Adjuntar"/>
              }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/pendientes_identidad" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/pendientes_identidad") &&
                <DashboardPage canalEstado='validacion_identidad' titulo="Mis Solicitudes" descripcion="Validación de Identidad"/>
              }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/validacion_identidad" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/pendientes_identidad") && <ClientIdentityValidation/>}
            </PrivateRoute>
            <PrivateRoute exact path="/admin/adjuntar_documentos" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/pendientes_adjuntar") && <AttachDocumentsPage />}
            </PrivateRoute>
            <PrivateRoute exact path="/admin/prospeccion-cliente" session={session}>
              {routesMenuByRolList.includes("mis_solicitudes/pendientes_adjuntar") && <ClientProspecting />}
            </PrivateRoute>
            <PrivateRoute exact path="/admin/simulator" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <SimulatorPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/agile-simulator" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador-agil") && <AgileSimulatorPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/send-habeas" session={session}>
              { routesMenuByRolList.includes("simulacion/envio-habeas") && <HabeasDataSenderPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/detalle-saldos" session={session}>
              { routesMenuByRolList.includes("simulacion/detalle_saldos") && <SimuladorRetanqueoPage/> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/client-list" session={session}>
              { routesMenuByRolList.includes("novedades/modificar_datos") && <ClientListPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/anular-list" session={session}>
              { routesMenuByRolList.includes("novedades/anular_creditos") && 
                <DashboardPage canalEstado="anular" titulo="Novedades" descripcion="Anular Créditos"/> 
              }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/client-modify" session={session}>
              { routesMenuByRolList.includes("novedades/modificar_datos") && <ClientModifyPage /> }
            </PrivateRoute>

            <PrivateRoute exact path="/admin/pagos" session={session}>
              {routesMenuByRolList.includes("novedades/pagos") && <PagosPage /> }
            </PrivateRoute>
            
            <PrivateRoute exact path="/admin/identity-validation" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <ClientIdentityValidationPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/client-registration" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <ClientRegistrationPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/global-debit" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <GlobalDebtPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/means-of-disbursement" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <MeansOfDisbursementPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/data-solicitation" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <DataSolicitationPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/life-insurance" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <LifeInsurancePage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/exception" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <ExceptionPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/international-operations" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <InternationalOperationsPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/ap-secure" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <ApSecurePage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/processed-exceptions" session={session}>
              { routesMenuByRolList.includes("simulacion/excepciones") && <ProcessedExceptionsPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/detail-exception" session={session}>
              { routesMenuByRolList.includes("simulacion/excepciones") && <DetailExceptionsPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/references" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <ReferencesPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/document-signing" session={session}>
              { routesMenuByRolList.includes("simulacion/simulador") && <DocumentSigningPage /> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/cdt" session={session}>
              { routesMenuByRolList.includes("cdt/consulta") && 
              <CdtProductListPage canalEstado="cdt" descripcion="Consulta de CDT"/> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/cdt-detail" session={session}>
              { routesMenuByRolList.includes("cdt/consulta") && 
              <CdtDetail/> }
            </PrivateRoute>
            <PrivateRoute exact path="/admin/survey" session={session}>
              <SurveyList titulo='Encuestas' descripcion='Administración de encuestas'/>
            </PrivateRoute>
            <PrivateRoute exact path="/admin/survey-detail" session={session}>
              <SurveyDetail/> 
            </PrivateRoute>
            
          </Switch>
        {(!hasSurveyDate || lastDate <= monthBefore) &&
        <SurveyContainer steps={questions} open={!hasSurveyDate || lastDate <= monthBefore} idAsesor={asesor}/> }
        <ModalInfo
        open={showModalCorretaje}
        setShowModal={setShowModalCorretaje}
        description={<div style={{textAlign: 'left'}}>Ejecutivo Freelance,<br></br>
        Nos haces falta. Recuerda que La Revolución Neofinanciera viene en camino y llega con más oportunidades 
        comerciales, por eso no olvides que <b>debes firmar la nueva modalidad de contrato</b> para acceder a tus beneficios. 
        Si ya firmaste el nuevo contrato, valida con tu Director de Oficina que todo este bien. Acá estamos para ti y para seguir creciendo juntos 
        ¡No te quedes sin aprovechar esta oportunidad!<br></br>
        <b>Identifica el contrato con el asunto del correo enviado: Signature requested on "Contrato de Corretaje</b>
        </div>}
        backgroundIcon={colors.grayLight}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        </DashbaordWrapper>
      </DashboardContainer>
    </SessionContext.Provider>
  )
}

export default MainPage;
